import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

/**
 * Commponent for rich-text fields
 */
@Component({
  selector: '[app-form-field-rich-text]',
  templateUrl: './form-field-rich-text.component.html',
})
export class FormFieldRichTextComponent implements OnInit, OnDestroy {
  @HostBinding('class.esf-form-item') public get formItemClass(): boolean {
    return true;
  }

  @Input() public optional: boolean = false;
  @Input() public placeholder: string = '';
  @Input() public label: string = '';
  @Input() public control: AbstractControl;
  @Input() public quillModules = {
    toolbar: [
      ['bold', 'italic'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link']
    ]
  };
  public id: string;
  constructor() { }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }


  public ngOnInit(): void {
    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  public ngOnDestroy(): void { }

}
